
function ContactComponent() {
    return (
      <div className="ErrorComponent">
        <h1>Missing</h1>
        <div>ContactComponent</div>
      </div>
    )
  }   
  
  
    export default ContactComponent;  